import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { GridAutocompleteEditCell } from './GridAutocompleteEditCell';
import { selectFacilityDetail } from '@AMIEWEB/Facility/FacilityStore/Facility.selector';
import { FacilityResponse } from 'app/models/Facility/FacilityDetails';
import { selectSkillsetLookupData } from 'store/redux-store/facility-preferences/selectors';
export const GridSubSpecialtyWrapper = props => {
  const { disciplineId, specialtyId } = props.row;
  const { disciplines, specialties, subSpecialties, subSpecialtyBySpecialty } = useSelector(selectSkillsetLookupData);
  const facilityDetail: FacilityResponse = useSelector(selectFacilityDetail);
  const [options, setOptions] = React.useState(subSpecialtyBySpecialty[specialtyId] || []);


  useEffect(() => {
    if (facilityDetail && disciplines) {
    }
  }, [facilityDetail, disciplines]);
  return <GridAutocompleteEditCell {...props} options={options} />;
};
